import { render } from "./SideMenu.vue?vue&type=template&id=ed883bb4&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=ed883bb4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed883bb4"
/* hot reload */
if (module.hot) {
  script.__hmrId = "ed883bb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed883bb4', script)) {
    api.reload('ed883bb4', script)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=ed883bb4&scoped=true", () => {
    api.rerender('ed883bb4', render)
  })

}

script.__file = "src/views/services/modules/voip/SideMenu.vue"

export default script